var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "menu_schedules--container",
      class: {
        "menu_schedules--container-active": _vm.isActive,
        "menu_schedules--container-fixed": _vm.isFixed,
      },
    },
    [
      _c(
        "a",
        {
          staticClass:
            "menu_schedules--handle visual_menu--glass_effect textual_menu--glass_effect material-icons",
          attrs: { href: "#", title: _vm.handleTitle },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.isActive = !_vm.isActive
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.handleIcon) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "menu_schedules--content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "menu_schedules--body" },
          [
            !_vm.normalizedSchedules.length
              ? _c("p", [_vm._v("No schedules configured for this menu.")])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.normalizedSchedules, function (schedule) {
              return _c("schedule-display", {
                key: schedule.schedule_id,
                class: {
                  "menu_schedules--schedule-active":
                    -1 !==
                    _vm.availabilityActiveSchedules.indexOf(
                      schedule.schedule_id
                    ),
                },
                attrs: { "normalized-schedule": schedule },
              })
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.normalizedSchedules.length
          ? _c(
              "div",
              { staticClass: "menu_schedules--footer" },
              [
                _c("p", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.availabilityDateTimeMessage.length,
                      expression: "availabilityDateTimeMessage.length",
                    },
                  ],
                  domProps: {
                    innerHTML: _vm._s(_vm.availabilityDateTimeMessage),
                  },
                }),
                _vm._v(" "),
                _c("text-input", {
                  attrs: {
                    label: "Check Menu Availability",
                    type: "datetime-local",
                  },
                  model: {
                    value: _vm.availabilityDateTime,
                    callback: function ($$v) {
                      _vm.availabilityDateTime = $$v
                    },
                    expression: "availabilityDateTime",
                  },
                }),
                _vm._v(" "),
                _c("material-button", {
                  attrs: { label: "Check" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.checkMenuAvailability.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "menu_schedules--header" }, [
      _c("h2", [_vm._v("Schedules")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }